<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Gestión de gastos no recurrentes</h4>
            <p>
              Aquí podrá gestionar la información relacionada con los
              <span class="text-success">gastos</span> variables de
              <span class="text-success">Avanza</span> por fecha
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <form
          @submit.prevent="
            obtenerInformacionGastos(fechaInicial, fechaFinal, categoria)
          "
        >
          <div class="col-md-3">
            <label for="fechaInicial">Fecha inicial:</label>
            <input
              type="date"
              v-model="fechaInicial"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label for="fechaInicial">Fecha final:</label>
            <input
              type="date"
              v-model="fechaFinal"
              required
              id="fechaInicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label for="fechaInicial">Categoria:</label>
            <select
              id="categoria"
              required
              class="form-control"
              v-model="categoria"
            >
              <option value="Todas">Todas</option>
              <option value="Prestamo">Préstamo</option>
              <option value="Gasto general">Gasto general</option>
              <option value="Gasto servicios">Gasto servicios</option>
            </select>
          </div>
          <div class="col-md-3">
            <br />
            <input
              type="submit"
              value="Buscar información"
              class="btn btn-success btn-fill"
            />
          </div>
        </form>
      </div>
      <div class="card" style="margin-top: 15px">
        <div class="row">
          <div class="col-md-3">
            <button
              class="btn btn-success btn-fill"
              @click="prepararRegistrar()"
            >
              Crear nuevo gasto
            </button>
          </div>
        </div>
        <div class="row">
          <center>
            <div class="col-md-12" v-if="queriedData2 == ''">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>

        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <br />
          <br />
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <br />
            <br />
          </div>
        </div>

        <div class="row" ref="component" v-if="queriedData2 != ''">
          <div class="col-md-12">
            <download-excel
              class="btn btn-secondary btn-fill mb-2"
              :data="json_data"
              :fields="json_fields"
              worksheet="gastos variables"
              name="Gastos avanza"
              v-if="json_data != ''"
            >
              Exportar a excel <i color="black" class="fa fa-download"></i>
            </download-excel>
            <br />
          </div>
          <div class="col-md-5">
            <br />
            <table>
              <tbody>
                <tr>
                  <td class="low-percentage">
                    <span class="color-box"></span>
                  </td>
                  <td>Registros de prestamos</td>
                </tr>
                <tr>
                  <td class="info-percentage">
                    <span class="color-box"></span>
                  </td>
                  <td>Registros sin categorias</td>
                </tr>
                <tr>
                  <td class="high-percentage">
                    <span class="color-box"></span>
                  </td>
                  <td>Registros de servicios</td>
                </tr>
                <tr>
                  <td class="medium-percentage">
                    <span class="color-box"></span>
                  </td>
                  <td>Registros de gastos generales</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <br />
            <el-table border :data="queriedData" class="table-responsive mt-2">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
                <template slot-scope="{ row }">
                  <div :class="getClass(column, row)" class="full-width">
                    <strong v-if="getClass(column, row) != ''">{{
                      formatearPesosColombianos(row[column.prop])
                    }}</strong>
                    <span v-else>{{ row[column.prop] }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :min-width="40">
                <template slot-scope="props">
                  <center>
                    <button
                      class="btn btn-simple btn-danger btn-icon like"
                      @click="deleteExpense(props.row)"
                    >
                      <i class="ti-trash"></i>
                    </button>
                  </center>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
      <modal
        name="registrar-gasto"
        :scrollable="true"
        height="auto"
        :reset="true"
      >
        <div class="modal-header" style="padding: 8px">
          <div class="row">
            <div class="col-md-12">
              <strong class="titulo-modal"> REGISTRA UN NUEVO GASTO </strong>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <form @submit.prevent="registrarGasto()">
              <div class="col-md-12">
                <label for="fecha">Fecha del gasto:</label>
                <input
                  type="date"
                  id="fecha"
                  v-model="form.fecha"
                  class="form-control"
                  required
                />
              </div>
              <div class="col-md-12">
                <label for="monto">Monto:</label>
                <input
                  type="number"
                  id="monto"
                  v-model="form.monto"
                  class="form-control"
                  required
                />
              </div>
              <div class="col-md-12">
                <label for="usuario">Usuario:</label>
                <select
                  id="usuario"
                  class="form-control"
                  v-model="form.usuario"
                >
                  <option value="">Seleccionar...</option>
                  <option
                    v-for="usuario in listUsers"
                    :key="usuario.id"
                    :value="usuario.usuario"
                  >
                    {{ usuario.nombreUsuario }}
                  </option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="categoria">Categoria</label>
                <select
                  id="categoria"
                  required
                  class="form-control"
                  v-model="form.categoria"
                >
                  <option value="Prestamo">Préstamo</option>
                  <option value="Gasto general">Gasto general</option>
                  <option value="Gasto servicios">Gasto servicios</option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="comentario">Comentarios:</label>
                <input
                  type="text"
                  id="comentario"
                  v-model="form.comentario"
                  class="form-control"
                  required
                />
              </div>
              <div class="col-md-12">
                <br />
                <center>
                  <button
                    type="button"
                    class="btn btn-seconday"
                    @click="cerrarModal()"
                  >
                    Cancelar
                  </button>
                  <input
                    type="submit"
                    value="Registrar"
                    class="btn btn-success btn-fill"
                  />
                </center>
              </div>
            </form>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    searchQuery: "",
    fechaInicial: "",
    fechaFinal: "",
    listUsers: [],
    categoria: "Todas",
    queriedData2: [],
    form: {
      fecha: "",
      monto: "",
      categoria: "Prestamo",
      comentario: "",
      usuario: "",
    },
    fechaActual: "",
    tableColumns: [
      {
        prop: "fecha",
        label: "Fecha",
        minWidth: 100,
      },
      {
        prop: "valor",
        label: "Monto $",
        minWidth: 100,
      },
      {
        prop: "usuario",
        label: "Usuario",
        minWidth: 110,
      },
      {
        prop: "comentario",
        label: "Comentario",
        minWidth: 300,
      },
    ],
    json_fields: {
      fecha: "fecha",
      monto: "valor",
      categoria: "categoria",
      comentarios: "comentario",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    SedesProgramacion: [],
    sede: "Sede Principal",
    rol: "",
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  components: {
    PPagination,
  },
  methods: {
    formatearPesosColombianos,
    prepararRegistrar: function () {
      this.$modal.show("registrar-gasto");
    },
    async obtenerInformacionGastos(fechaInicial, fechaFinal, categoria) {
      try {
        this.$modal.show("carga");
        const sede = localStorage.getItem("sede");
        const response = await axiosInstance.get(
          `api/informe-gastos-variables/${fechaInicial}/${fechaFinal}/${categoria}`
        );
        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    async registrarGasto() {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.post(
          `api/newExpenseVariable`,
          this.form
        );
        if (response.data.status == true) {
          this.$notify(crearAlerta("success", response.data.mensaje));
          this.obtenerInformacionGastos(this.form.fecha, this.form.fecha);
          this.fechaInicial = this.form.fecha;
          this.fechaFinal = this.form.fecha;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.$notify(
          crearAlerta("danger", "Ocurrió un error, intentelo de nuevo.")
        );
      } finally {
        this.$modal.hide("carga");
        this.$modal.hide("registrar-gasto");
      }
    },
    deleteExpense: async function (gasto) {
      try {
        this.$modal.show("carga");
        const data = { id: gasto.id };
        const response = await axiosInstance.post(`api/deleteExpense`, data);

        if (response.data.status === true) {
          this.$notify(crearAlerta("success", response.data.mensaje));
          this.obtenerInformacionGastos(
            this.fechaInicial,
            this.fechaFinal,
            this.categoria
          );
        } else {
          this.$notify(crearAlerta("danger", response.data.mensaje));
        }
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    getListUsers: async function () {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get(`api/get-list-users`);

        if (response.data.status === true) {
          this.listUsers = response.data.data;
        } else {
          this.$notify(crearAlerta("danger", response.data.mensaje));
        }
      } catch (error) {
        this.$notify(crearAlerta("danger", error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    resetForm: function () {
      this.form.fecha = "";
      this.form.monto = "";
      this.form.categoria = "Prestamo";
      this.form.comentario = "";
      this.form.usuario = "";
    },
    cerrarModal: function () {
      this.resetForm();
      this.$modal.hide("registrar-gasto");
    },
    getClass(column, row) {
      if (column.prop === "valor") {
        if (row.categoria === "Prestamo") {
          return "low-percentage";
        }

        if (row.categoria === "Gasto general") {
          return "medium-percentage";
        }

        if (row.categoria === "Gasto servicios") {
          return "high-percentage";
        }

        return "info-percentage";
      }
      return "";
    },
  },
  mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de salarios";
    this.getListUsers();
  },
};
</script>
  
  <style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.info-percentage {
  background-color: #5f8afe;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

table {
  width: 50%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  border: none;
}
th,
td {
  border: none;
  padding: 0px;
  text-align: left;
}
th {
  background-color: #f2f2f2;
}
.color-box {
  width: 5px;
  height: 5px;
  display: inline-block;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/gastosVariables.vue